<div class="row quick-upload">
  <div class="col-md-12">
    <h3 class="text-capitalize">
      <fa-icon [icon]="['fas', 'info-circle']" />
      {{ 'dias.quickorder.page.csv.title' | translate }}
    </h3>
    <form [formGroup]="csvForm" (ngSubmit)="uploadQuickOrder()">
      <div class="form-group section section-seperator">
        <div class="row">
          <div class="col-md-2">
            <label for="CSVFile" class="btn-primary">
              {{ 'dias.quickorder.page.file.upload.ChooseFile' | translate }}
              <input
                #CSVFile
                type="file"
                name="csvFile"
                id="CSVFile"
                size="35"
                class="form-control d-none field-focus"
                accept=".csv,.xlsx,.xls"
                (change)="uploadListener($event.target)"
              />
            </label>
          </div>

          <div class="col-md-3">
            <input
              type="text"
              class="form-control csvfilename field-focus"
              placeholder="no file selected"
              name="csvFileName"
              [formControl]="csvFileName"
            />
            <div>
              @switch (status) { @case ('IncorrectInput') {
              <small class="has-error"
                ><span class="validation-message">{{
                  'dias.quickorder.page.csv.file.invalid.input' | translate
                }}</span></small
              >
              } @case ('InvalidFormat') {
              <small class="has-error"
                ><span class="validation-message">{{
                  'dias.quickorder.page.csv.file.invalid.format' | translate
                }}</span></small
              >
              } @case ('ValidFormat') {
              <small class="has-success"
                ><span class="validation-message">{{ 'quickorder.page.csv.file.uploaded' | translate }}</span></small
              >
              } @default {
              <small></small>
              } }
            </div>
          </div>

          <div class="col-md-4">
            <button type="submit" class="btn btn-primary" name="addToCartCSV" [disabled]="isCsvDisabled">
              {{ 'dias.quickorder.page.add.cart' | translate }}
            </button>
          </div>
        </div>

        <ng-container>
          <div class="alert-danger mt-2">
            @for (validationError of quickOrderValidationErrors$ | async; track validationError) {
            <div class="quickorder-error-message">
              {{ validationError.message }}
            </div>
            }
          </div>
        </ng-container>

        <div class="row">
          <div class="col-md-4 col-lg-2">
            <div
              class="form-text mt-3 text-center"
              [innerHTML]="'dias.quickorder.page.csv.sample' | translate : { '0': 'assets/sample-data/quickorder.xls' }"
            ></div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
